const initialState = {
    searchedTag: {
        data: "message"
    }
}


export const tagSearchReducer = (state = initialState, action) => {
    switch (action.type) {

        case "SET_SEARCHED_TAG": {
            return { ...state, searchedTag: action.data }
        }

        default:
            return state;

    }
};